<ul class="layout-menu">
  <ng-container *ngFor="let item of models; let i = index">
    <li
      pegasus-menu-item
      *ngIf="item && !item.separator"
      [item]="item"
      [index]="i"
      [root]="true"
    ></li>
    <li *ngIf="item && item.separator" class="menu-separator"></li>
  </ng-container>
</ul>
